/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2020-09-09 11:43:34
 */
import { Message, Notification } from 'element-ui'
export class NotifyMsg {
  create (type: any = 'warning', message: string, duration = 3000) {
    Message({
      type: type,
      message: message,
      duration: duration
    })
  }

  showNotify (title: string, type: any, message: string, duration = 3000) {
    Notification({
      title,
      type,
      message,
      duration
    })
  }
}
const notify = new NotifyMsg()
export default notify
